var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormulateInput',_vm._b({attrs:{"help-position":"after","dropzone-options":_vm.dropzoneOptions}},'FormulateInput',Object.assign({}, _vm.$props, _vm.$attrs),false))}
var staticRenderFns = []

export { render, staticRenderFns }